/**
 * Mock data pre podnety (initiatives)
 */

import { officials, ovmIds } from "./officials";

const generateDate = (yearsAgo, monthOffset = 0, dayOffset = 0) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - yearsAgo);
  date.setMonth(date.getMonth() + monthOffset);
  date.setDate(date.getDate() + dayOffset);
  return date.toISOString();
};

export const initiatives = [
  {
    id: "init-001",
    person: {
      firstName: "Tomáš",
      lastName: "Občan",
      email: "tomas.obcan@email.cz",
      phone: "+420777111222",
    },
    official: {
      id: officials[0].id,
      firstName: officials[0].firstName,
      lastName: officials[0].lastName,
      ovmId: ovmIds.ministerstvo,
      ovmName: "Ministerstvo financí",
    },
    officialFullName: `${officials[0].firstName} ${officials[0].lastName}`,
    state: { name: "NEW" },
    text: "Podávám podnět na nesrovnalosti v majetkovém přiznání funkcionáře. V oznámení není uvedena nemovitost, kterou vlastní.",
    created: generateDate(0, 0, -3),
    ovmName: "Ministerstvo financí",
  },
  {
    id: "init-002",
    person: {
      firstName: "Marie",
      lastName: "Veřejná",
      email: "marie.verejna@email.cz",
      phone: "+420777222333",
    },
    official: {
      id: officials[3].id,
      firstName: officials[3].firstName,
      lastName: officials[3].lastName,
      ovmId: ovmIds.snemovna,
      ovmName: "Poslanecká sněmovna",
    },
    officialFullName: `${officials[3].firstName} ${officials[3].lastName}`,
    state: { name: "ACCEPT" },
    text: "Upozorňuji na možný střet zájmů poslankyně - její manžel podniká v oboru, o kterém rozhoduje ve výboru.",
    created: generateDate(0, -1, -10),
    investigationStartDate: generateDate(0, 0, -20),
    ovmName: "Poslanecká sněmovna",
  },
  {
    id: "init-003",
    person: {
      firstName: "Petr",
      lastName: "Aktivista",
      email: "petr.aktivista@ngo.cz",
      phone: "+420777333444",
    },
    official: {
      id: officials[4].id,
      firstName: officials[4].firstName,
      lastName: officials[4].lastName,
      ovmId: ovmIds.mestoBrno,
      ovmName: "Statutární město Brno",
    },
    officialFullName: `${officials[4].firstName} ${officials[4].lastName}`,
    state: { name: "REPLY" },
    closedResult: "JUSTIFIED",
    text: "Podnět na nedostatky v oznámení primátora - chybí informace o některých příjmech.",
    created: generateDate(0, -4, 0),
    investigationStartDate: generateDate(0, -3, -15),
    closedDate: generateDate(0, -1, 0),
    closedNote:
      "Podnět byl shledán důvodným. Funkcionář byl vyzván k doplnění oznámení.",
    ovmName: "Statutární město Brno",
  },
  {
    id: "init-004",
    person: {
      firstName: "Jana",
      lastName: "Kontrolorka",
      email: "jana.kontrolorka@email.cz",
      phone: "+420777444555",
    },
    official: {
      id: officials[1].id,
      firstName: officials[1].firstName,
      lastName: officials[1].lastName,
      ovmId: ovmIds.senat,
      ovmName: "Senát ČR",
    },
    officialFullName: `${officials[1].firstName} ${officials[1].lastName}`,
    state: { name: "REJECT" },
    closedResult: "UNJUSTIFIED",
    text: "Podávám podnět na senátorku ohledně údajných nepravdivých údajů v oznámení.",
    created: generateDate(0, -6, 0),
    investigationStartDate: generateDate(0, -5, -10),
    closedDate: generateDate(0, -2, 0),
    closedNote:
      "Podnět byl prošetřen a shledán nedůvodným. Údaje v oznámení jsou v souladu se zákonem.",
    ovmName: "Senát ČR",
  },
  {
    id: "init-005",
    person: {
      firstName: "Karel",
      lastName: "Novinář",
      email: "karel.novinar@press.cz",
      phone: "+420777555666",
    },
    official: {
      id: officials[6].id,
      firstName: officials[6].firstName,
      lastName: officials[6].lastName,
      ovmId: ovmIds.krajBrno,
      ovmName: "Jihomoravský kraj",
    },
    officialFullName: `${officials[6].firstName} ${officials[6].lastName}`,
    state: { name: "NEW" },
    text: "Podnět na bývalého hejtmana - v oznámení nejsou uvedeny všechny příjmy z vedlejší činnosti.",
    created: generateDate(0, 0, -7),
    ovmName: "Jihomoravský kraj",
  },
  {
    id: "init-006",
    person: {
      firstName: "Lucie",
      lastName: "Anonymní",
      email: "lucie.anon@proton.me",
      phone: null,
    },
    official: {
      id: officials[2].id,
      firstName: officials[2].firstName,
      lastName: officials[2].lastName,
      ovmId: ovmIds.mestoPraha,
      ovmName: "Magistrát hl. m. Prahy",
    },
    officialFullName: `${officials[2].firstName} ${officials[2].lastName}`,
    state: { name: "ACCEPT" },
    text: "Anonymní podnět na radního pro dopravu - podezření na propojení s dopravní firmou.",
    created: generateDate(0, -2, -5),
    investigationStartDate: generateDate(0, -1, -15),
    ovmName: "Magistrát hl. m. Prahy",
  },
  {
    id: "init-007",
    person: {
      firstName: "Martin",
      lastName: "Pracovitý",
      email: "martin.pracovity@email.cz",
      phone: "+420777666777",
    },
    official: {
      id: officials[5].id,
      firstName: officials[5].firstName,
      lastName: officials[5].lastName,
      ovmId: ovmIds.obecRoztoky,
      ovmName: "Obec Roztoky",
    },
    officialFullName: `${officials[5].firstName} ${officials[5].lastName}`,
    state: { name: "REPLY" },
    closedResult: "PARTIAL",
    text: "Podnět na starostku obce - některé údaje v oznámení jsou neúplné.",
    created: generateDate(0, -3, 0),
    investigationStartDate: generateDate(0, -2, -20),
    closedDate: generateDate(0, -1, -5),
    closedNote: "Podnět byl částečně důvodný. Některé údaje byly upřesněny.",
    ovmName: "Obec Roztoky",
  },
  {
    id: "init-008",
    person: {
      firstName: "Eva",
      lastName: "Bdělá",
      email: "eva.bdela@email.cz",
      phone: "+420777777888",
    },
    official: {
      id: officials[7].id,
      firstName: officials[7].firstName,
      lastName: officials[7].lastName,
      ovmId: ovmIds.ministerstvoPrace,
      ovmName: "Ministerstvo práce a sociálních věcí",
    },
    officialFullName: `${officials[7].firstName} ${officials[7].lastName}`,
    state: { name: "NEW" },
    text: "Podnět na náměstkyni ministra - podezření na nesoulad mezi příjmy a životním stylem.",
    created: generateDate(0, 0, -1),
    ovmName: "Ministerstvo práce a sociálních věcí",
  },
  {
    id: "init-009",
    person: {
      firstName: "Ondřej",
      lastName: "Ostražitý",
      email: "ondrej.ostrazity@email.cz",
      phone: "+420777888999",
    },
    official: {
      id: officials[10].id,
      firstName: officials[10].firstName,
      lastName: officials[10].lastName,
      ovmId: ovmIds.senat,
      ovmName: "Senát ČR",
    },
    officialFullName: `${officials[10].firstName} ${officials[10].lastName}`,
    state: { name: "FORWARDED" },
    text: "Podnět na senátora - v oznámení není uvedena účast v orgánech obchodních společností.",
    created: generateDate(0, -1, -3),
    investigationStartDate: generateDate(0, 0, -15),
    ovmName: "Senát ČR",
  },
  {
    id: "init-010",
    person: {
      firstName: "Radka",
      lastName: "Reportérka",
      email: "radka.reporterka@media.cz",
      phone: "+420777999000",
    },
    official: {
      id: officials[11].id,
      firstName: officials[11].firstName,
      lastName: officials[11].lastName,
      ovmId: ovmIds.ministerstvo,
      ovmName: "Ministerstvo financí",
    },
    officialFullName: `${officials[11].firstName} ${officials[11].lastName}`,
    state: { name: "REJECT" },
    closedResult: "UNJUSTIFIED",
    text: "Podnět na ředitelku odboru MF - údajné nepravdivé informace o majetku.",
    created: generateDate(0, -5, 0),
    investigationStartDate: generateDate(0, -4, -10),
    closedDate: generateDate(0, -2, -15),
    closedNote: "Prošetřením nebylo zjištěno porušení zákona.",
    ovmName: "Ministerstvo financí",
  },
];

// Iniciatívy pre verejnosť
export const initiativesPublic = initiatives.map((init) => ({
  id: init.id,
  text: init.text.substring(0, 100) + "...",
  state: init.state,
  created: init.created,
}));

export default initiatives;
